import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate, fmtDateTime } from '../../../../utils/fmt';

const SalesForecastList = () => {
  const { customerId } = useParams();

  const decodedCustomerId = customerId ? atob(customerId).replace(/\D/g, '') : '';
  const fetchUrl = decodedCustomerId
    ? `${API_DOMAIN}${API_ROUTES.salesForecast}?customer=${decodedCustomerId}`
    : `${API_DOMAIN}${API_ROUTES.salesForecast}`;

  const columns = [
    { label: 'Forecast Date', value: (item) => fmtDate(item.forecast_date) },
    { label: 'Forecast Amount', value: 'forecast_amount' },
    { label: 'Updated At', value: (item) => fmtDateTime(item.updated_at) },
    { label: 'Customer', value: item => item.customer?.name || 'N/A' },
    { label: 'Created By', value: item => item.created_by?.username || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/sales-forecast/details/${id}`;
  };

  return (
    <div>
      <h1>Sales Forecasts</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default SalesForecastList;
